// One breakpoint for the whole app. 'screen' keeps print layouts unaffected.
export const MOBILE_MEDIA_QUERY = 'screen and (max-width: 768px)';
